import { render, staticRenderFns } from "./ProfileSidebar.vue?vue&type=template&id=90dd7e40&scoped=true"
import script from "./ProfileSidebar.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileSidebar.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProfileSidebar.vue?vue&type=style&index=0&id=90dd7e40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90dd7e40",
  null
  
)

export default component.exports